export default "__VITE_ASSET__CH$xPqaj__"